import styled, { css } from 'styled-components';
import { Title as BaseTitle } from '@getinapp/appetizer';

export const Container = styled.div`
  width: 100%;
`;

export const Title = styled(BaseTitle)`
  font-size: 2rem;
  margin-bottom: 0.5rem;
`;

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubTitle = styled.strong`
  font-size: 2.4rem;
`;

export const TitleSpan = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;
  `};
`;
